import React from 'react';

import { ListOption, ListOptionGroup } from '../../../../design-system';

const ProjectMoreOptionPopup = ({ onClose, setActionModal }) => {
    const openModal = (action) => {
        setActionModal({ action });
        onClose();
    };

    return (
        <div className="absolute top-[110%] right-0 z-20">
            <ListOptionGroup
                fixedWidth={300}
                listOptions={
                    <>
                        <ListOption
                            leadingIconName="editLineIcon"
                            text="Rename"
                            onClick={() => openModal('rename')}
                        />
                        <ListOption
                            leadingIconName="inboxArchiveLineIcon"
                            text="Archive"
                            onClick={() => openModal('archive')}
                        />
                    </>
                }
                handleClose={(e) => {
                    e?.stopPropagation();
                    e?.preventDefault();
                    onClose();
                }}
            />
        </div>
    );
};

export default ProjectMoreOptionPopup;
